module.exports = "/_next/static/images/image-b12b0f56c41dd70dc8d9d34d5bd16a0e.svg";